// src/data/dateStampData.js

import date1 from "../assets/datestamp/IMG-20250828-WA0005.jpg";
import date2 from "../assets/datestamp/IMG-20250828-WA0006.jpg";
import date3 from "../assets/datestamp/IMG-20250828-WA0007.jpg";
import date4 from "../assets/datestamp/IMG-20250828-WA0008.jpg";

const numberingStampData
 = [
  {
    id: 1,
    name: "Numbering Stamp 6 digit",
    image: date1,
    category: "Numbering",
    size: "Medium",
    description: "Durable date stamp for office and personal use."
  },
  {
    id: 2,
    name: "Numbering Stamp 16 digit",
    image: date2,
    category: "Numbering",
    size: "Large",
    description: "Compact date stamp, easy to carry and efficient."
  },
  {
    id: 3,
    name: "Numbering Stamp 10 digit",
    image: date3,
    category: "Numbering",
    size: "Large",
    description: "Heavy-duty date stamp with clear impressions."
  },
  {
    id: 4,
    name: "Numbering Stamp 6 digit",
    image: date4,
    category: "Numbering",
    size: "Medium",
    description: "Reliable self-inking date stamp for frequent use."
  }
];

export default numberingStampData
;
